import { render } from "./InActiveUsers.vue?vue&type=template&id=2cdd509c"
import script from "./InActiveUsers.vue?vue&type=script&lang=js"
export * from "./InActiveUsers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__